import React from 'react'
import {filter, get, isNil, map} from 'lodash'
import Dates from '../helpers/dates'
import * as dateRangeHelpers from "helpers/dateRangeSelectors"
import {getDateRangeSelectors} from 'helpers/dateRangeSelectors'

const getLabelForDateRange = (value) => {
  const range = getAllDateRangeControl().find(range => range.value === value)
  if (range) return range.label
  return null
}

export const datePickerRanges = {
  'default': [
    dateRangeHelpers.today,
    dateRangeHelpers.yesterday,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.lastWeek,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.lastMonth,
    dateRangeHelpers.thisQuarter,
    dateRangeHelpers.lastQuarter,
    dateRangeHelpers.thisFinancialYear,
    dateRangeHelpers.lastFinancialYear,
    dateRangeHelpers.thisYear,
    dateRangeHelpers.lastYear,
  ],
  'future-short': [
    dateRangeHelpers.today,
    dateRangeHelpers.tomorrow,
    dateRangeHelpers.next7Days,
    dateRangeHelpers.next14Days,
    dateRangeHelpers.next30Days,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.nextWeek,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.nextMonth,
  ],
  'past-short': [
    dateRangeHelpers.today,
    dateRangeHelpers.yesterday,
    dateRangeHelpers.last7Days,
    dateRangeHelpers.last14Days,
    dateRangeHelpers.last30Days,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.lastWeek,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.lastMonth,
  ],
  'future-long': [
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.nextMonth,
    dateRangeHelpers.thisQuarter,
    dateRangeHelpers.nextQuarter,
    dateRangeHelpers.thisFinancialQuarter,
    dateRangeHelpers.nextFinancialQuarter,
    dateRangeHelpers.thisFinancialYear,
    dateRangeHelpers.nextFinancialYear,
    dateRangeHelpers.thisYear,
    dateRangeHelpers.nextYear,
  ],
  'past-long': [
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.lastMonth,
    dateRangeHelpers.thisQuarter,
    dateRangeHelpers.lastQuarter,
    dateRangeHelpers.thisFinancialQuarter,
    dateRangeHelpers.lastFinancialQuarter,
    dateRangeHelpers.thisFinancialYear,
    dateRangeHelpers.lastFinancialYear,
    dateRangeHelpers.thisYear,
    dateRangeHelpers.lastYear,
  ],
  'leads-board': [
    dateRangeHelpers.today,
    dateRangeHelpers.yesterday,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.lastWeek,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.lastMonth,
    dateRangeHelpers.thisQuarter,
    dateRangeHelpers.lastQuarter,
  ],
  'activities-board': [
    dateRangeHelpers.today,
    dateRangeHelpers.tomorrow,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.lastWeek,
    dateRangeHelpers.nextWeek,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.lastMonth,
    dateRangeHelpers.nextMonth,
    dateRangeHelpers.thisYear,
    dateRangeHelpers.lastYear,
  ],
  'approvals-board': [
    dateRangeHelpers.today,
    dateRangeHelpers.yesterday,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.lastWeek,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.lastMonth,
    dateRangeHelpers.thisYear,
    dateRangeHelpers.lastYear,
  ],
  'deliveries-board': [
    dateRangeHelpers.today,
    dateRangeHelpers.yesterday,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.lastWeek,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.lastMonth,
    dateRangeHelpers.thisYear,
    dateRangeHelpers.lastYear,
  ],
}

export const getDateRangeControlForDatePickerRange = (type = 'default') => datePickerRanges[type]


const getAllDateRangeControl = () => {

  const dateRangeControl = [
    dateRangeHelpers.today,
    dateRangeHelpers.yesterday,
    dateRangeHelpers.tomorrow,
    dateRangeHelpers.thisWeek,
    dateRangeHelpers.lastWeek,
    dateRangeHelpers.nextWeek,
    dateRangeHelpers.lastMonth,
    dateRangeHelpers.thisMonth,
    dateRangeHelpers.nextMonth,
    dateRangeHelpers.lastQuarter,
    dateRangeHelpers.thisQuarter,
    dateRangeHelpers.nextQuarter,
    dateRangeHelpers.lastYear,
    dateRangeHelpers.thisYear,
    dateRangeHelpers.nextYear,
    dateRangeHelpers.lastFinancialYear,
    dateRangeHelpers.thisFinancialYear,
    dateRangeHelpers.nextFinancialYear,
    dateRangeHelpers.last24hours,
    dateRangeHelpers.last2Days,
    dateRangeHelpers.last3Days,
    dateRangeHelpers.last7Days,
    dateRangeHelpers.last14Days,
    dateRangeHelpers.last30Days,
    dateRangeHelpers.last60Days,
    dateRangeHelpers.last90Days,
    dateRangeHelpers.next24Hours,
    dateRangeHelpers.next2Days,
    dateRangeHelpers.next3Days,
    dateRangeHelpers.next7Days,
    dateRangeHelpers.next14Days,
    dateRangeHelpers.next30Days,
    dateRangeHelpers.next60Days,
    dateRangeHelpers.next90Days,
  ]
  // Add the Weeks
  for (let i = 2; i <= 12; i++) {
    dateRangeControl.push({value: 'weeks:-' + i, label: 'Last ' + i + ' Weeks'})
  }
  for (let i = 2; i <= 12; i++) {
    dateRangeControl.push({value: 'weeks:' + i, label: 'Next ' + i + ' Weeks'})
  }

  // Add the Months
  for (let i = 2; i <= 12; i++) {
    dateRangeControl.push({value: 'months:-' + i, label: 'Last ' + i + ' Months'})
  }
  for (let i = 2; i <= 12; i++) {
    dateRangeControl.push({value: 'months:' + i, label: 'Next ' + i + ' Months'})
  }

  for (let i = 2; i <= 12; i++) {
    const label = i + ' Months Ago'
    dateRangeControl.push({value: 'month:-' + i, label})
  }

  for (let i = 2; i <= 12; i++) {
    const label = i + ' Months Ahead'
    dateRangeControl.push({value: 'month:' + i, label})
  }

  // Add the Quarters
  for (let i = 2; i <= 8; i++) {
    const label = i + ' Quarters Ago'
    dateRangeControl.push({value: 'quarter:-' + i, label})
  }
  for (let i = 2; i <= 8; i++) {
    const label = i + ' Quarters Ahead'
    dateRangeControl.push({value: 'quarter:' + i, label})
  }

  // Add the Financial Quarters
  for (let i = 2; i <= 10; i++) {
    const label = i + ' Financial Quarters Ago'
    dateRangeControl.push({value: 'fquarter:-' + i, label})
  }
  dateRangeControl.push({value: 'fquarter:-1', label: 'Last Financial Quarter'})
  dateRangeControl.push({value: 'fquarter:0', label: 'This Financial Quarter'})
  dateRangeControl.push({value: 'fquarter:1', label: 'Next Financial Quarter'})
  for (let i = 2; i <= 10; i++) {
    const label = i + ' Financial Quarters Ahead'
    dateRangeControl.push({value: 'fquarter:' + i, label})
  }

  // Add the Years
  for (let i = 2; i <= 10; i++) {
    dateRangeControl.push({value: 'years:-' + i, label: 'Last ' + i + ' Years'})
  }
  for (let i = 2; i <= 10; i++) {
    dateRangeControl.push({value: 'years:' + i, label: 'Next ' + i + ' Years'})
  }

  for (let i = 2; i <= 10; i++) {
    const label = i + ' Years Ago'
    dateRangeControl.push({value: 'year:-' + i, label})
  }

  for (let i = 2; i <= 10; i++) {
    const label = i + ' Years Ahead'
    dateRangeControl.push({value: 'year:' + i, label})
  }

  // Add the Financial Years
  for (let i = 2; i <= 10; i++) {
    const label = i + ' Financial Years Ago'
    dateRangeControl.push({value: 'fyear:-' + i, label})
  }
  for (let i = 2; i >= 10; i++) {
    const label = i + ' Financial Years Ahead'
    dateRangeControl.push({value: 'fyear:' + i, label})
  }

  return dateRangeControl
}

export const getDateFilters = (filters, invoiceFinancialYearStart) => {
  const timeKey = get(filters, 'timeKey', null)
  if (isNil(timeKey)) {
    return {
      targetStart: filters.targetStart,
      targetEnd: filters.targetEnd,
    }
  }

  const {startDate, endDate} = getDateRangeForKey(timeKey, invoiceFinancialYearStart, true)
  return {
    targetStart: isNil(startDate) ? null : startDate.getTime(),
    targetEnd: isNil(endDate) ? null : endDate.getTime(),
  }
}

export const getDateRangeForKey = (timeKey, invoiceFinancialYearStart, returnDateObject = false) => {
  const now = new Date()
  return getDateRangeForKeyAndDate(timeKey, now, invoiceFinancialYearStart, returnDateObject)
}

export const getDateSelectorLabelForKey = (timeKey) => {
  const dateSelector = getDateRangeSelectors.find(dateSelector => dateSelector.value === timeKey)
  return isNil(dateSelector)
    ? 'Custom'
    : dateSelector.label
}

export const expandDateRange = (startDate, endDate) => {
  const daysToSubtract = {0: 6, 1: 0, 2: 1, 3: 2, 4: 3, 5: 4, 6: 5}
  const daysToAdd = {0: 1, 1: 0, 2: 6, 3: 5, 4: 4, 5: 3, 6: 2}
  startDate.setDate(startDate.getDate() - daysToSubtract[startDate.getDay()])
  endDate.setDate(endDate.getDate() + daysToAdd[endDate.getDay()])
}

export const getDateRangeForKeyAndDate = (
  timeKey,
  now,
  financialYearStart,
  returnDateObject = false,
  expandRange = false
) => {
  financialYearStart = financialYearStart - 1 // turn 1-based into 0-based
  let startDate = new Date()
  let endDate = new Date()
  const day = now.getDate()
  const month = now.getMonth()
  let dayOfWeek = now.getDay() - 1
  if (dayOfWeek < 0) dayOfWeek = 6
  const year = now.getFullYear()
  const lastMidnight = new Date(year, month, day)
  const thisMidnight = new Date(year, month, day + 1)

  const getFinancialYear = () => {
    const year = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]
    return [...year.slice(financialYearStart, 12), ...year.slice(0, financialYearStart)]
  }

  const getStartOfFinancialQuarter = () => {
    const financialYear = getFinancialYear()
    const index = Math.floor((financialYear.indexOf(month)) / 3) * 3
    return financialYear[index]
  }

  if (!isNil(timeKey)) {
    if (timeKey.startsWith('days:')) {
      const count = parseInt(timeKey.substring(5))
      if (count < 0) {
        startDate = new Date(year, month, day + count + 1)
        endDate = thisMidnight
      } else {
        startDate = lastMidnight
        endDate = new Date(year, month, day + count)
      }

    } else if (timeKey.startsWith('weeks:')) {
      const count = parseInt(timeKey.substring(6))
      if (count < 0) {
        startDate = new Date(year, month, day + 7 - dayOfWeek + (7 * count))
        endDate = new Date(year, month, day + 7 - dayOfWeek)
      } else {
        startDate = new Date(year, month, day - dayOfWeek)
        endDate = new Date(year, month, day - dayOfWeek + (7 * count))
      }

    } else if (timeKey.startsWith('months:')) {
      const count = parseInt(timeKey.substring(7))
      if (count < 0) {
        startDate = new Date(year, month + count + 1, 1)
        endDate = new Date(year, month + 1, 1)
      } else {
        startDate = new Date(year, month, 1)
        endDate = new Date(year, month + count, 1)
      }

    } else if (timeKey.startsWith('quarters:')) {
      const count = parseInt(timeKey.substring(9))
      if (count < 0) {
        let endMonth = month - (month % 3) + 3
        let endYear = year
        if (endMonth > 11) {
          endMonth -= 12
          endYear++
        }

        let startMonth = endMonth + (count * 3)
        let startYear = endYear
        while (startMonth < 0) {
          startMonth += 12
          startYear--
        }

        startDate = new Date(startYear, startMonth, 1)
        endDate = new Date(endYear, endMonth, 1)

      } else {
        const startMonth = month - (month % 3)

        let endMonth = startMonth + (count * 3)
        let endYear = year
        while (endMonth > 11) {
          endMonth -= 12
          endYear++
        }

        startDate = new Date(year, startMonth, 1)
        endDate = new Date(endYear, endMonth, 1)
      }

    } else if (timeKey.startsWith('years:')) {
      const count = parseInt(timeKey.substring(6))
      if (count < 0) {
        startDate = new Date(year + count + 1, 0, 1)
        endDate = new Date(year + 1, 0, 1)
      } else {
        startDate = new Date(year, 0, 1)
        endDate = new Date(year + count, 0, 1)
      }

    } else if (timeKey.startsWith('day:')) {
      const count = parseInt(timeKey.substring(4))
      startDate = new Date(year, month, day + count)
      endDate = new Date(year, month, day + count + 1)

    } else if (timeKey.startsWith('week:')) {
      const count = parseInt(timeKey.substring(5))
      startDate = new Date(year, month, day - dayOfWeek + (count * 7))
      endDate = new Date(year, month, day + (7 - dayOfWeek) + (count * 7))

    } else if (timeKey.startsWith('month:')) {
      const count = parseInt(timeKey.substring(6))
      startDate = new Date(year, month + count, 1)
      endDate = new Date(year, month + count + 1, 1)
      if (expandRange) {
        expandDateRange(startDate, endDate)
      }

    } else if (timeKey.startsWith('quarter:')) {
      const count = parseInt(timeKey.substring(8)) * 3
      const startMonth = month - (month % 3) + count
      const endMonth = startMonth + 3
      startDate = new Date(year, startMonth, 1)
      endDate = new Date(year, endMonth, 1)

    } else if (timeKey.startsWith('year:')) {
      const count = parseInt(timeKey.substring(5))
      startDate = new Date(year + count, 0, 1)
      endDate = new Date(year + count + 1, 0, 1)

    } else if (timeKey.startsWith('fyear:')) {
      const count = parseInt(timeKey.substring(6)) // TODO finish date calculation
      if (month < financialYearStart) {
        startDate = new Date(year + count - 1, financialYearStart, 1)
        endDate = new Date(year + count, financialYearStart, 1)
      } else {
        startDate = new Date(year + count, financialYearStart, 1)
        endDate = new Date(year + count + 1, financialYearStart, 1)
      }

    } else if (timeKey.startsWith('fquarter:')) {
      const count = parseInt(timeKey.substring(9)) * 3 // TODO finish date calculation
      const startMonth = getStartOfFinancialQuarter()
      const startYear = (startMonth > month) ? year - 1 : year
      const endMonth = startMonth + 3
      startDate = new Date(startYear, parseInt(startMonth + count), 1)
      endDate = new Date(startYear, parseInt(endMonth + count), 1)

    } else if (timeKey.startsWith('custom:')) {
      const parts = timeKey.split(':')
      startDate = null
      endDate = null
      if (parts.length > 1 && parts[1].length > 0) startDate = new Date(parseInt(parts[1]))
      if (parts.length > 2 && parts[2].length > 0) endDate = new Date(parseInt(parts[2]))
    } else if (timeKey.startsWith('all')) {
      startDate = null
      endDate = null
    }
  }

  return returnDateObject
    ? {startDate, endDate}
    : {
      startDate: startDate ? startDate.getTime() : null,
      endDate: endDate ? endDate.getTime() : null,
    }
}

const getTotalDateRangeControl = () => {
  return {value: 'custom:', label: 'All'}
}

const getHistoryDateRangeControl = () => {
  return [
    getTotalDateRangeControl(),
    ...filter(getAllDateRangeControl(), o => o.value.indexOf(':-') > -1 || o.value.indexOf(':0') > 0),
  ]
}

const getFutureDateRangeControl = () => {
  return [
    getTotalDateRangeControl(),
    ...filter(getAllDateRangeControl(), o => o.value.indexOf(':-') === -1),
  ]
}

// Helper function to list all the date range filters in order to test them
export const getObjectDateFilters = (invoiceFinancialYearStart) => {
  const dateRangeFilters = getAllDateRangeControl()
  return map(dateRangeFilters, filter => {
    const timeKey = filter.value
    const timeLabel = filter.label
    const dateRange = getDateRangeForKey(timeKey, invoiceFinancialYearStart)
    const startDate = Dates.getDateTimeString(dateRange.startDate)
    const endDate = Dates.getDateTimeString(dateRange.endDate)
    return (
      <div key={timeKey}>
        <b>{timeLabel}</b><br/>
        {timeKey}<br/>
        {startDate}<br/>
        {endDate}<br/>
        <br/>
        <br/>
      </div>
    )
  })
}

export const getPropertyForDateRangePicker = (timeKey, property = 'label') => {
  const option = getDateRangeControlForDatePickerRange().find(option => option.value === timeKey)
  return option ? option[property] : null
}

export default {
  getHistoryDateRangeControl,
  getFutureDateRangeControl,
  getAllDateRangeControl,
  getDateRangeForKey,
  getLabelForDateRange,
  getObjectDateFilters,
  getDateRangeForKeyAndDate,
  getDateRangeControlForDatePickerRange,
  getPropertyForDateRangePicker,
}
